import { makeStyles } from '@material-ui/core/styles'
import FormControl from '@mui/material/FormControl'
import { InputAdornment, OutlinedInput } from '@mui/material'
import Button from '@mui/material/Button'
import { useState } from 'react'
import { convertAmountToLakhs } from 'src/utils/commonMethods/buyPolicy'

const PriceDetails = ({ carDetails, handleChange }) => {
  const classes = useStyles()
  const [exShowroomPrice, setExShowroomPrice] = useState(
    carDetails?.exShowroomPrice?.value
  )

  const handleNext = (amount = 0) => {
    handleChange({
      exShowroomPrice: {
        value: amount,
      },
    })
  }

  const handleExShowroomPrice = (event) => {
    setExShowroomPrice(event?.target?.value)
  }

  return (
    <div className={classes.mainContainer}>
      <div className={classes.mainHeading}>
        Car&apos;s ex-showroom price, please?
      </div>
      <div className={classes.subHeading}>
        So we can tailor your coverage accordingly.
      </div>
      <div className={classes.inputContainer}>
        <FormControl
          variant='outlined'
          className={`${classes.inputValue} ${classes.formControlStyles}`}
        >
          <OutlinedInput
            id='outlined-adornment-weight'
            type='number'
            startAdornment={
              <InputAdornment position='start' className={classes.rsText}>
                Rs.
              </InputAdornment>
            }
            value={exShowroomPrice}
            onChange={handleExShowroomPrice}
            endAdornment={
              <InputAdornment
                position='end'
                className={classes.inputText}
                id='input'
              >
                | {convertAmountToLakhs(exShowroomPrice)} Lac
              </InputAdornment>
            }
            aria-describedby='outlined-weight-helper-text'
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
            className={classes.outLineField}
          />
        </FormControl>
      </div>
      {/* <div className={classes.submitButtonConatiner}>
        <Button variant='contained' onClick={handleSubmit} className={classes.submitButton}>
          Submit
        </Button>
      </div> */}
      <div className={classes.actionsContainer}>
        <Button
          id='NextButton'
          variant='contained'
          onClick={() => handleNext(exShowroomPrice)}
          className={classes.nextButton}
        >
          Next
        </Button>
      </div>
      <div
        className={classes.dontKnowText}
        onChange={() => handleNext()}
        id='dontKnowText'
      >
        I don&apos;t know my car&apos;s ex-showroom price
      </div>
    </div>
  )
}

export default PriceDetails

const useStyles = makeStyles({
  mainContainer: {
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '82px',
  },
  outLineField: {
    '&  .MuiOutlinedInput-input': {
      fontSize: '13px',
      fontWeight: '600',
    },
  },
  mainHeading: {
    fontSize: '17px',
    fontFamily: 'Roboto',
    fontWeight: '700',
    textAlign: 'center',
  },
  subHeading: {
    fontSize: '11px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    color: '#7B7B7B',
    textAlign: 'center',
    padding: '5px',
  },
  submitButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    minWidth: '225px !important',
    borderRadius: '5px !important',
  },
  dontKnowText: {
    fontSize: '11px',
    fontFamily: 'Roboto',
    fontWeight: '400',
    color: '#21AFE5',
    textAlign: 'center',
    padding: '20px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '13px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    fontWeight: '600',
  },
  inputContainer: {
    display: 'flex',
    padding: '10px',
    justifyContent: 'space-between',
    minWidth: '188px',
    marginTop: '20px',
    marginBottom: '10px',
  },
  rsText: {
    fontSize: '13px',
    fontWeight: '600',
    fontFamily: 'Roboto',
    color: '#B1B1B1',
  },
  inputText: {
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: '#696969',
  },
  inputValue: {
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  nextButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
  formControlStyles: {
    width: '25ch',
    margin: 1,
  },
})
